module.exports = __webpack_public_path__ + "static/conduccion---panel-de-control-22623c06c8ea61682f0dbeb0d486dbd5.jpg";